// utils/SkeletonLoading.ts

/**
 * Adds a 'skeleton' class to the specified HTML element.
 * This is typically used to apply a loading placeholder effect.
 *
 * @param {HTMLElement} component - The HTML element to apply the skeleton effect to.
 */
export function addSkeletonLoading(component: HTMLElement): void {
	component.classList.add('skeleton');
}

/**
 * Removes the 'skeleton' class from the specified HTML element.
 * This is used to remove the loading placeholder effect once content is loaded.
 *
 * @param {HTMLElement} component - The HTML element to remove the skeleton effect from.
 */
export function removeSkeletonLoading(component: HTMLElement): void {
	component.classList.remove('skeleton');
}
